// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// Redux Actions
import {changePassword, changePasswordReset, clearError} from '../../actions/change-password-actions';
import {logout} from '../../actions/auth-actions';

// Core Libs
import validators from '../../lib/core/validators';

// Components
import Button from '../core/button';
import Error from '../core/error';
import Loading from '../core/loading';

// Contexts
import {RouteContext} from '../../contexts/route-context';

// Styles
import './change-password.scss';

class ChangePassword extends Component {
    oldPasswordInput = React.createRef();

    newPasswordInput = React.createRef();

    newPasswordInputConfirm = React.createRef();

    state = {
        error: null,
    };

    componentWillMount() {
        const {clearError} = this.props;

        clearError();
    }

    componentDidMount() {
        this.focusOnPasswordInput();
    }

    componentWillUpdate(nextProps) {
        const {changePasswordReset, fetching, logout} = this.props;
        const {push} = this.context;
        const {error} = this.state;

        if (nextProps.error && error !== nextProps.error) {
            this.setState({error: nextProps.error});
        } else if (fetching && !nextProps.fetching) {
            this.setState({error: null}, () => {
                push('/');
                changePasswordReset();
                logout();
                window.location.reload();
            });
        }
    }

    componentDidUpdate() {
        this.focusOnPasswordInput();
    }

    getCancelProps() {
        return {
            className: 'change-password--cancel',
            onClick: this.handleCancelClick,
        };
    }

    getSubmitProps() {
        return {
            type: 'submit',
            onClick: this.handleSubmit,
        };
    }

    handleCancelClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        const {push} = this.context;

        push('/');
        window.location.reload();
    };

    handleSubmit = (event) => {
        event && event.preventDefault && event.preventDefault();

        const {changePassword} = this.props;
        const validatePassword = validators.password(this.newPasswordInput.current.value);

        if (this.newPasswordInput.current.value !== this.newPasswordInputConfirm.current.value) {
            this.setState({error: 'Passwords must match.'});
        } else if (!this.oldPasswordInput.current.value) {
            this.setState({error: 'Your current password is required to make changes.'});
        } else if (validatePassword) {
            this.setState({error: validatePassword});
        } else {
            this.setState({error: null}, () =>
                changePassword(this.oldPasswordInput.current.value, this.newPasswordInput.current.value)
            );
        }
    };

    focusOnPasswordInput() {
        if (this.oldPasswordInput.current && this.oldPasswordInput.current.focus) {
            this.oldPasswordInput.current.focus();
        }
    }

    render() {
        const {fetching} = this.props;
        const {error} = this.state;

        return (
            <div className="change-password">
                <form className="change-password--form" name="change-password">
                    <label>Current Password</label>
                    <input
                        data-test-id="change-password.current-password"
                        ref={this.oldPasswordInput}
                        type="password"
                    />
                    <label>New Password</label>
                    <input data-test-id="change-password.new-password" ref={this.newPasswordInput} type="password" />
                    <label>Confirm Password</label>
                    <input
                        data-test-id="change-password.confirm-password"
                        ref={this.newPasswordInputConfirm}
                        type="password"
                    />
                    <Button {...this.getSubmitProps()} data-test-id="change-password.submit">
                        Submit
                    </Button>
                    <Button {...this.getCancelProps()} data-test-id="change-password.cancel">
                        Cancel
                    </Button>
                    <Error error={error} />
                    <Loading loading={fetching} />
                </form>
            </div>
        );
    }
}

ChangePassword.propTypes = {
    changePassword: PropTypes.func.isRequired,
    changePasswordReset: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    logout: PropTypes.func.isRequired,
};

ChangePassword.contextType = RouteContext;

const mapStateToProps = (state) => ({...state.changePassword});

const mapDispatchToProps = {
    changePassword,
    changePasswordReset,
    clearError,
    logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
